import gql from 'graphql-tag';

export class FormLinesInput {
  id: number;
  aa: number;
  notes: string;
  containerorderId: number;
  containerTypeId: number;
  quantity: number;

  constructor() {
    this.id = undefined;
    this.aa = undefined;
    this.notes = undefined;
    this.containerorderId = undefined;
    this.containerTypeId = undefined;
    this.quantity = undefined;
  }
}

export class FormInput {
  id: number;
  orderNo: string;
  seriesId: number;
  codePrefix: string;
  codeNumber: number;
  dateOrdered: Date;
  datePosted: Date;
  isApproved: boolean;
  judgeNotes: string;
  judgedByUser: string;
  judgeDate: Date;
  notes: string;

  isActive: boolean;
  statusId: number;
  containerorderTypeId: number;
  collectionPointId: number;
  collectorId: number;
  sendDocumentId: string;
  lines: {
    id: number;
    aa: number;
    notes: string;
    containerorderId: number;
    containerTypeId: number;
    containertype: {
      id: number;
      name: string;
    };
    quantity: number;
    sendDocumentId: string;
  };

  constructor() {
    this.id = undefined;
    this.orderNo = undefined;
    this.seriesId = undefined;
    this.codePrefix = undefined;
    this.codeNumber = undefined;
    this.dateOrdered = undefined;
    this.datePosted = undefined;
    this.isApproved = undefined;
    this.judgeNotes = undefined;
    this.judgedByUser = undefined;
    this.judgeDate = undefined;
    this.notes = undefined;
    this.isActive = undefined;
    this.statusId = undefined;
    this.containerorderTypeId = undefined;
    this.collectionPointId = undefined;
    this.collectorId = undefined;
    this.sendDocumentId = undefined;
    this.lines = undefined;
  }
}

export const gqlGetQuery = gql`
  query getContainersorders($limit: Int, $offset: Int, $order: String, $where: String) {
    getContainersorders(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        orderNo
        seriesId
        codePrefix
        codeNumber
        dateOrdered
        datePosted
        isApproved
        judgeNotes
        judgedByUser
        judgeDate
        notes
        isActive
        # Relations
        statusId
        containerorderState {
          id
          name
        }
        containerorderTypeId
        containerordertype {
          id
          name
        }
        collectionPointId
        collectionpoint {
          id
          name
          addressLine1
          addressLine2
          addressArea
          addressCity
          addressNomos
          profession {
            id
            name
          }
        }
        sendDocumentId
        collectorId
        collector {
          id
          name
        }
        lines {
          id
          aa
          notes
          containerOrderId
          containerTypeId
          containertype {
            id
            name
          }
          quantity
          binSerialNo
        }
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getContainersorderById($id: Int) {
    getContainersorderById(id: $id) {
      id
      orderNo
      seriesId
      codePrefix
      codeNumber
      dateOrdered
      datePosted
      isApproved
      judgeNotes
      judgedByUser
      judgeDate
      notes
      drivernotes
      isActive
      # Relations
      statusId
      containerorderState {
        id
        name
      }
      containerorderTypeId
      containerordertype {
        id
        name
      }
      collectionPointId
      collectionpoint {
        id
        name
      }
      lines {
        id
        aa
        notes
        containerOrderId
        containerTypeId
        containertype {
          id
          name
        }
        quantity
        binSerialNo
      }
      collectorId
      collector {
        id
        name
      }
      sendDocumentId
      firstUser
      firstDate
      lastUser
      lastDate
    }
  }
`;

export const gqlAdd = gql`
  mutation addContainersorder($data: ContainersorderInput) {
    addContainersorder(data: $data) {
      id
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateContainersorder($data: ContainersorderInput) {
    updateContainersorder(data: $data) {
      id
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteContainersorder($id: Int) {
    deleteContainersorder(id: $id)
  }
`;
export const DELETE_CONTAINER_ORDER_LINE = gql`
  mutation deleteContainerorderLine($id: Int) {
    deleteContainerorderLine(id: $id)
  }
`;
